import React, { Component, ReactNode } from 'react'
import { Trans, t, plural, Plural } from '@lingui/macro'

import { Modal } from '../../../components/common/modal/Modal'
import { notification } from '../../../components/common/notifications/Notifications'
import userRemoveFromGroup from '../../../operations/userRemoveFromGroup'
import { ButtonClean, ButtonDanger } from 'front-end/src/components'
import { eachTargetId } from 'front-end/src/pages/manage-users-page/ManageUsersPageContext'

interface IProps {
  groupId: number
  userIds: number[]
  show: boolean
  onCanceled: () => void
  onDeleted: (userIds, groupId) => void
}

interface IState {
  isDeleting: boolean
}

class UserBatchRemoveFromGroupModal extends Component<IProps, IState> {
  state: IState = {
    isDeleting: false
  }

  handleOnDelete = async (): Promise<void> => {
    const { groupId, userIds, onDeleted } = this.props

    this.setState({ isDeleting: true })

    try {
      await eachTargetId(userIds, async (userId) =>
        userRemoveFromGroup(groupId, userId)
      )
      notification.info(
        plural(userIds.length, {
          one: 'User was successfully removed from this group.',
          other: `${userIds.length} users were successfully removed from this group.`
        })
      )
      onDeleted(userIds, groupId)
    } catch {
      notification.warning(
        t`Error while removing users from this group, please try again.`
      )
    }

    this.setState({ isDeleting: false })
  }

  renderControls(): JSX.Element {
    const { onCanceled } = this.props
    const { isDeleting } = this.state

    return (
      <>
        <ButtonClean onClick={onCanceled}>
          <Trans>Cancel</Trans>
        </ButtonClean>
        <ButtonDanger isLoading={isDeleting} onClick={this.handleOnDelete}>
          <Trans>Remove from group</Trans>
        </ButtonDanger>
      </>
    )
  }

  render(): ReactNode {
    const { onCanceled, show } = this.props

    return (
      <Modal
        header={
          this.props.userIds.length > 1
            ? t`Remove users from this group`
            : t`Remove user from this group`
        }
        show={show}
        controls={this.renderControls()}
        onHide={onCanceled}
      >
        <p>
          <Trans>
            <Plural
              value={this.props.userIds.length}
              one="Are you sure you want to remove this user from this group?"
              other="Are you sure you want to remove these users from this group?"
            />
          </Trans>
        </p>
      </Modal>
    )
  }
}

export default UserBatchRemoveFromGroupModal
